=<template>
	<div>
		<j-expendable-box class="bg5 b1 bc7 r2">
			<!-- Header -->
			<div slot="header" class="pl3 pr3 pt4 pb4 lh125 fs4 c1 fw7">
				{{ $t("credentials") }}
			</div>

			<!-- Body -->
			<div class="bt1 bc7" slot="body">
				<j-list :list="computedFields">
					<div class="flex xs-12 p3" slot="list" slot-scope="{ item }">
						<!-- Label -->
						<div class="flex xs-6 xs-left xs-middle fw7 c6 lh125">
							{{ item.label }}
						</div>

						<!-- Value -->
						<div class="flex xs-4 xs-left xs-middle lh125">
							<span
								:class="[
									{
										'p1 r2 fw7 bgError--l5 cError--d4 fs3':
											item.key === 'status' &&
											item.value.toString().toLowerCase() === 'rejected'
									}
								]"
							>
								{{ item.value || "---" }}
							</span>
						</div>

						<!-- Actions -->
						<div class="flex xs-2 xs-right xs-middle">
							<crm-icon
								name="edit"
								color="c2"
								class="cu2"
								v-if="item.hasUpdate"
								@click.native="handleUpdateItem(item.key)"
							/>
							<crm-icon
								name="delete"
								color="cError"
								class="ml2 cu2"
								v-if="item.hasDelete"
							/>
						</div>
					</div>
				</j-list>
			</div>
		</j-expendable-box>

		<!-- Modal -->
		<core-modal name="proposalCredentialsUpdate" :headline="$t('update')">
			<div class="p4">
				<core-form-input
					v-if="itemUpdate === 'status'"
					name="name"
					componentName="j-base-input-text"
					:label="$t('status')"
					v-model="form.status"
				/>
				<core-form-input
					v-if="itemUpdate === 'referralCode'"
					name="referralCode"
					componentName="j-base-input-text"
					:label="$t('referral_code')"
					v-model="form.referralCode"
				/>
				<j-button
					@click="updateProposal(itemUpdate)"
					class="mt6"
					:isLoading="isLoading"
				>
					{{ $t("update") }}
				</j-button>
			</div>
		</core-modal>
	</div>
</template>

<script>
import JList from "@/components/JList"
import JExpendableBox from "@/components/JExpendableBox"
import CrmIcon from "@/components/CrmIcon"
import CoreModal from "@/modules/core/components/CoreModal"
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"

import dayjs from "dayjs"
import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		JList,
		JExpendableBox,
		CrmIcon,
		CoreModal,
		CoreFormInput,
		JButton
	},

	data() {
		return {
			isLoading: false,
			itemUpdate: "",
			form: {
				status: this.$store.getters["caseManagement/proposal"]?.status,
				referralCode: this.$store.getters["caseManagement/proposal"]
					?.referralCode
			}
		}
	},

	computed: {
		computedFields() {
			const dateFormat = this.$store.state.settings.dateFormat
			const proposal = this.$store.getters["caseManagement/proposal"] || null
			if (!proposal) return []

			let {
				status,
				createdAt,
				createdBy,
				lastModifiedAt,
				lastModifiedBy,
				referralCode
			} = proposal

			// Massage data for display
			status = status ? status : "---"
			createdAt = createdAt ? dayjs(createdAt).format(dateFormat) : ""
			lastModifiedAt = lastModifiedAt
				? dayjs(lastModifiedAt).format(dateFormat)
				: ""
			createdBy = createdBy?.username ? createdBy?.username : ""
			lastModifiedBy = lastModifiedBy?.username ? lastModifiedBy?.username : ""

			// Return data
			return [
				{
					key: "status",
					label: this.$t("status"),
					value: status,
					hasUpdate: true
				},
				{ key: "createdAt", label: this.$t("created_at"), value: createdAt },
				{ key: "createdBy", label: this.$t("created_by"), value: createdBy },
				{
					key: "lastModifiedAt",
					label: this.$t("updated_at"),
					value: lastModifiedAt
				},
				{
					key: "lastModifiedBy",
					label: this.$t("updated_by"),
					value: lastModifiedBy
				},
				{
					key: "referralCode",
					label: this.$t("referral_code"),
					value: referralCode,
					hasUpdate: true
				}
			]
		}
	},

	methods: {
		async updateProposal(key) {
			const query = gql`
				mutation updateProposal(
					$caseId: String!
					$proposalId: String!
					$input: updateProposalInput!
				) {
					updateProposal(
						caseId: $caseId
						proposalId: $proposalId
						input: $input
					) {
						status
						errors
					}
				}
			`
			const variables = {
				caseId: this.$store.state.caseManagement.caseId,
				proposalId: this.$store.state.caseManagement.proposalId,
				input: {
					[key]: this.form?.[key]
				}
			}

			this.isLoading = true

			const res = await api({ query, variables })

			this.isLoading = false

			if (res?.data?.updateProposal?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateProposal?.errors ||
							res?.data?.updateProposal?.errors_2.message ||
							"Oops ! An error occured."
					}
				})
			}

			const stateFilter = function(state) {
				return state.proposals?.find(item => item.id === state?.proposalId)
			}
			// Update type
			this.$store.commit("caseManagement/UPDATE_CASE", {
				actionType: "update",
				fieldName: key,
				value: this.form?.[key],
				stateFilter
			})

			this.$modal.hide("proposalCredentialsUpdate")
		},
		handleUpdateItem(key) {
			this.itemUpdate = key
			this.$modal.show("proposalCredentialsUpdate")
		}
	}
}
</script>
